import { WarningOutlined } from "@ant-design/icons";
import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GetUnitObjectivesApi from "../../api/units/GetUnitObjectivesApi";
import ObjectiveCard from "../cards/ObjectiveCard";
import TopPlanCard from "../cards/TopPlanCard";
import PageLoader from "../sub/PageLoader";

const { Option } = Select;

function UnitObjectives() {
  const [canStart, setCanStart] = useState(false);
  const [canShow, setCanShow] = useState(false);
  const [plans, setPlans] = useState();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const proHeight = document.body.clientHeight;
  let curLocation = useLocation();

  useEffect(() => {
    getUnitPlans();
  }, [curLocation]);

  async function getUnitPlans() {
    let path = curLocation.pathname;
    let id = path.split("/units/");
    const apiResponse = await GetUnitObjectivesApi(id[1], perfCycleState.id);
    if (apiResponse.message === "success") {
      setPlans(apiResponse.plans);
      if (apiResponse.plans?.length) {
        setCanShow(true);
      }
    }
    setCanStart(true);
  }

  function renderPlans() {
    let output = [];

    plans?.forEach((plan) => {
      output.push(<TopPlanCard plan={plan} />);
    });

    return output;
  }

  function showEmptyPlans() {
    return (
      <div
        style={{ height: proHeight - 188 }}
        className="flex justify-center items-center w-full h-full"
      >
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No plans available
          </div>
          <div className="mb-3 text-gray-400">No plans added to this unit</div>
        </div>
      </div>
    );
  }

  return canStart ? (
    canShow ? (
      <div className="pb-8">
        {/* <div className="mb-6 flex">
          <div className="mr-6">
            <div className="mb-2">Objective group</div>
            <Select
              className="w-48"
              defaultValue="all"
              placeholder="Select target scale"
            >
              <Option value="all">All</Option>
              <Option value="currency">Financial</Option>
              <Option value="department">Customer</Option>
              <Option value="division">Learning</Option>
              <Option value="division">Internal</Option>
            </Select>
          </div>
          <div>
            <div className="mb-2">Progress</div>
            <Select
              className="w-48"
              defaultValue="all"
              placeholder="Select target scale"
            >
              <Option value="all">All</Option>
              <Option value="currency">On track</Option>
              <Option value="department">Off track</Option>
              <Option value="division">At risk</Option>
            </Select>
          </div>
        </div> */}
        {renderPlans()}
      </div>
    ) : (
      showEmptyPlans()
    )
  ) : (
    <PageLoader />
  );
}

export default UnitObjectives;
